import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ActionInputIcon, InputBGIcon } from "../formControl";
import { InputV2 } from "../input";

import type { ISearchInputProps } from "./types";

import { useDebounced, useReadOnly } from "@/hooks";
import { Icon } from "@/components/atoms/icons";

export function SearchInput(props: ISearchInputProps) {
  const {
    value = "",
    onDebouncedValueChange,
    onChange,
    readOnly: propsReadOnly,
    disabled,
    placeholder,
    ...rest
  } = props;
  const { t } = useTranslation("field");
  const readOnly = useReadOnly(propsReadOnly);
  const debouncedValue = useDebounced(value, 800);

  useEffect(() => {
    onDebouncedValueChange?.(debouncedValue || value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const canDelete = !(value === "" || readOnly || disabled);

  function clear() {
    if (!canDelete) return;
    onDebouncedValueChange?.("");
    onChange?.("");
  }

  return (
    <InputV2
      actionIcon={
        canDelete && (
          <ActionInputIcon onClick={clear}>
            <Icon name={"CloseCircle"} />
          </ActionInputIcon>
        )
      }
      bgIcon={
        !canDelete && (
          <InputBGIcon>
            <Icon name={"Magnifer"} />
          </InputBGIcon>
        )
      }
      onChange={onChange}
      placeholder={placeholder || t("doSearch")}
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      {...rest}
    />
  );
}
